
import { createAction, props } from "@ngrx/store";
import { EntityAcreditacionEmpresa } from "./entity-acreditacion-empresa.model";

export const EntityAcreditacionEmpresaLoadRequest = createAction(
  '[ENTITYACREDITACIONEMPRESA] Load Request'
);

export const EntityAcreditacionEmpresaLoadFailure = createAction(
  '[ENTITYACREDITACIONEMPRESA] Load Failure',
  props<{ error: Error }>()
);

export const EntityAcreditacionEmpresaLoadSuccess = createAction(
  '[ENTITYACREDITACIONEMPRESA] Load Success',
  props<{ items: EntityAcreditacionEmpresa[] }>()
);

export const EntityAcreditacionEmpresaAddRequest = createAction(
  '[ENTITYACREDITACIONEMPRESA] Add Request',
  props<{ item: EntityAcreditacionEmpresa }>()
);

export const EntityAcreditacionEmpresaAddFailure = createAction(
  '[ENTITYACREDITACIONEMPRESA] Add Failure',
  props<{ error: Error }>()
);

export const EntityAcreditacionEmpresaAddSuccess = createAction(
  '[ENTITYACREDITACIONEMPRESA] Add Success',
  props<{ item: EntityAcreditacionEmpresa }>()
);

export const EntityAcreditacionEmpresaDeleteRequest = createAction(
  '[ENTITYACREDITACIONEMPRESA] Delete Request',
  props<{ item: EntityAcreditacionEmpresa }>()
);

export const EntityAcreditacionEmpresaDeleteFailure = createAction(
  '[ENTITYACREDITACIONEMPRESA] Delete Failure',
  props<{ error: Error }>()
);

export const EntityAcreditacionEmpresaDeleteSuccess = createAction(
  '[ENTITYACREDITACIONEMPRESA] Delete Success',
  props<{ item: EntityAcreditacionEmpresa }>()
);

export const EntityAcreditacionEmpresaUpdateRequest = createAction(
  '[ENTITYACREDITACIONEMPRESA] Update Request',
  props<{ item: EntityAcreditacionEmpresa }>()
);

export const EntityAcreditacionEmpresaUpdateFailure = createAction(
  '[ENTITYACREDITACIONEMPRESA] Update Failure',
  props<{ error: Error }>()
);

export const EntityAcreditacionEmpresaUpdateSuccess = createAction(
  '[ENTITYACREDITACIONEMPRESA] Update Success',
  props<{ item: EntityAcreditacionEmpresa }>()
);
